module.exports = __webpack_public_path__ + "static/media/xiaoxue_tiyu.dac5bd8d.png";